export class AdminDocument {

    id?: string;
    name: string = '';
    description: string = '';
    isMandatory: string = '';
    hasExpirationDate: string = '';
    requestedTo?: string;
    uploadStatus?: string;
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    url?: string;
    modelUrl?: string;

    constructor(raw?: AdminDocument) {

        if (raw) {
            this.id = raw.id;
            this.name = raw.name;
            this.description = raw.description;
            this.isMandatory = raw.isMandatory;
            this.hasExpirationDate = raw.hasExpirationDate;
            this.requestedTo = raw.requestedTo;
            this.uploadStatus = raw.uploadStatus;
            this.status = raw.status;
            this.url = raw.url;
            this.createdAt = raw.createdAt;
            this.updatedAt = raw.updatedAt;
            this.modelUrl = raw.modelUrl;
        }
    }
}
